import translate from '../translations.json';

export default class ClickCollect {
  constructor() {
    this.address = '';

    document.querySelector('.text-container form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.geocoder();
    });

    this.lang = document.documentElement.lang;
    this.translations = translate;
    this.locations;
  }

  geocoder() {
    let address = document.querySelector('form fieldset input#address').value;

    let geocoder = new google.maps.Geocoder();
    geocoder.geocode( { 'address': address}, (results, status) => {
      if (status == 'OK') {
        this.address = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };
        this.openResult();
      } else {
        alert(this.translations[this.lang].error + status);
      }
    });
  }

  openResult() {
    var xhttp = new XMLHttpRequest();
    let that = this;
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        that.locations = JSON.parse(this.responseText);

        let restaurants = [];

        that.locations.forEach( location => {
          if (location.acf.lien_click_collect) {
            let cuisine = [location.acf.nom_de_la_cuisine, that.getDistance(location.acf.latitude, location.acf.longitude), [that.translations[that.lang].selectReastaurant, location.acf.lien_click_collect]];
              restaurants.push(cuisine);
          }
        });

        let datas = [];
        if(restaurants.length > 0){
          restaurants.forEach( r => {
              datas.push( r );
          } );
          that.showResult( datas );
        }
      }
    };

    xhttp.open('GET', '/wp-json/acf/v3/kitchens?per_page=20', true);
    xhttp.send();
  }

  getDistance(lat, lng) {
    let distance = 0;
    const cdn = [this.address.lat, this.address.lng];

    const dLat = (cdn[0] - lat) / 180* Math.PI;
    const dLong = (cdn[1] - lng) / 180 * Math.PI;

    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
                + Math.cos(lat / 180* Math.PI) * Math.cos(cdn[0] / 180* Math.PI) 
                * Math.sin(dLong/2) * Math.sin(dLong/2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    //Calculate radius of earth
    // For this you can assume any of the two points.
    const radiusE = 6378135; // Equatorial radius, in metres
    const radiusP = 6356750; // Polar Radius

    //Numerator part of function
    let nr = Math.pow(radiusE * radiusP * Math.cos(lat / 180 * Math.PI), 2);
    //Denominator part of the function
    let dr = Math.pow(radiusE * Math.cos(lat / 180 * Math.PI), 2)
                    + Math.pow(radiusP * Math.sin(lat / 180 * Math.PI), 2);
    let radius = Math.sqrt(nr / dr);

    //Calculate distance in meters.
    distance = radius * c;

    return distance;
  }

  showResult(datas) {
    document.querySelector('.text-container.results').innerHTML = '';

    let restaurants = document.createElement('div');
    restaurants.classList.add('restaurants');
    document.querySelector('.text-container.results').appendChild( restaurants );

    datas.forEach( data => {
      let node = document.createElement('div');
      node.classList.add('restaurant');
      node.setAttribute('data-distance', data[1]);
      restaurants.appendChild( node );

      let title = document.createElement('p');
      title.classList.add('title');
      let textTitle = document.createTextNode( data[0] );
      title.appendChild( textTitle );
      node.appendChild( title );

      let url = document.createElement('a');
      let textUrl = document.createTextNode( data[2][0] );
      url.href = data[2][1];
      url.setAttribute('target', '_blank');
      url.appendChild( textUrl );
      node.appendChild( url );
    });

    let paragraphWrapper = document.createElement('p'),
      linkWrapper = document.createElement('a');

    let linkText = document.createTextNode(this.translations[this.lang].collectFooterLinkText);
    linkWrapper.href = 'https://www.bigmammagroup.com/fr/click-collect';
    linkWrapper.setAttribute('target', '_blank');
    linkWrapper.appendChild( linkText );

    let textFooter = document.createTextNode(this.translations[this.lang].collectFooterMessage);
    paragraphWrapper.classList.add('footer');
    paragraphWrapper.appendChild( textFooter );
    paragraphWrapper.appendChild( linkWrapper );
    document.querySelector('.text-container.results').appendChild( paragraphWrapper );

    this.orderDatas(document.querySelector('.text-container.results .restaurants'));
  }

  orderDatas(table) {
    const itemsArray = Array.prototype.slice.call(table.children);
    itemsArray.sort((a, b) => {
      return a.dataset.distance - b.dataset.distance
    });

    itemsArray.forEach((item) => {
      table.appendChild(item);
    });
  }
}